// Sequenced setup for leaflet-rotate.
//
// leaflet-rotate ships as a UMD bundle that references the global `L`. Under Vite/ESM,
// leaflet is loaded as a module and never attached to window, so the plugin runs against
// an undefined `L` and silently no-ops.
//
// Splitting this into its own file forces a deterministic evaluation order: this module
// finishes (with `window.L` populated) BEFORE `leaflet-rotate` executes its patches.
import L from 'leaflet';
(window as any).L = L;

// Custom-pane fix for leaflet-rotate.
//
// leaflet-rotate's _initPanes puts the built-in tilePane/overlayPane inside `rotatePane`
// (which receives the rotation/positioning transforms). But user-created panes (via
// react-leaflet's <Pane>) call createPane(name) WITHOUT a parent, which defaults to mapPane —
// so those panes sit as siblings to rotatePane and never get the rotate-aware transform.
// Result: polylines in custom panes render at the wrong screen position.
//
// We monkey-patch createPane so when rotation is enabled and no parent is specified, the
// pane is parented to rotatePane. The plugin's own pane setup passes parent explicitly,
// so this only affects user-added panes — exactly what we want.
const _origCreatePane = L.Map.prototype.createPane;
L.Map.prototype.createPane = function (name: string, parent?: HTMLElement) {
	if (!parent && (this as any)._rotate) {
		const rp = this.getPane('rotatePane');
		if (rp) parent = rp;
	}
	return _origCreatePane.call(this, name, parent);
};
